<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">{{ !loading ? (isEditMode ? "Edit" : "Create") : "" }} Setting</div>
    </div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/internalsetting">Back to Internal Settings</a>
    </div>
    <div class="col-md-12 well-content">
        @if (successMsg) {
            <div class="alert alert-success">{{ successMsg }}</div>
        }
        @if (errorMsg) {
            <div class="alert alert-danger">{{ errorMsg }}</div>
        }
        <div class="panel panel-default">
            <div class="panel-body">
                <form #frm="ngForm" class="form-horizontal">
                    <div class="form-group">
                        <label for="KeyName" class="col-md-2 control-label">
                            Name
                            @if (!internalSetting.KeyID) {
                                <span style="color: red"> *</span>
                            }
                        </label>
                        <div class="col-md-6">
                            <input
                                name="KeyName"
                                type="text"
                                required
                                [readonly]="internalSetting.KeyID"
                                maxlength="1024"
                                #nameMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="internalSetting.KeyName" />
                            @if (nameMdl.touched && nameMdl.invalid) {
                                <span class="text-danger">Name is required</span>
                            }
                        </div>
                    </div>
                    <!--
          <div class="form-group">
            <label for="KeyValue" class="col-md-2 control-label">Value</label>
            <div class="col-md-6">
              <textarea
                style="resize: both"
                rows="7"
                name="KeyValue"
                class="form-control"
                [(ngModel)]="internalSetting.KeyValue">
              </textarea>
            </div>
          </div>
          -->
                    <div class="form-group">
                        <label for="KeyValue" class="col-md-2 control-label">Value</label>
                        @if (!internalSetting.IsBoolean) {
                            <div class="col-md-6">
                                <input
                                    type="number"
                                    name="KeyValue1"
                                    class="form-control"
                                    min="30"
                                    max="365"
                                    #valueMdl="ngModel"
                                    required
                                    [(ngModel)]="internalSetting.KeyValue" />
                                @if (valueMdl.touched && valueMdl.invalid) {
                                    <span class="text-danger">Value must be between 30 and 365.</span>
                                }
                            </div>
                        }
                        @if (internalSetting.IsBoolean) {
                            <div class="col-md-6">
                                <nz-switch
                                    name="KeyValue2"
                                    nzSize="default"
                                    required
                                    [(ngModel)]="internalSetting.BoolValue"
                                    [nzCheckedChildren]="checkedTmpl"
                                    [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                            </div>
                        }
                    </div>
                </form>
            </div>
        </div>
        <button class="btn btn-default" (click)="save(frm)">Save Changes</button>
        <!--
      <button *ngIf="internalSetting.KeyID" class="btn btn-danger pull-right" (click)="remove()">
        Delete Setting
      </button>
      -->
    </div>
</div>
<ng-template #checkedTmpl>Enabled</ng-template>
<ng-template #uncheckedTmpl>Disabled</ng-template>
